import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useCommunityMaster } from "../../store/community/reducer";
import { REQUEST_DELETE_MASTER_COMMUNITY } from "../../store/community/communityActionTypes";
interface CommunityDeleteProps {
  event: any;
  isOpen: boolean;
  onClose: () => void;
}

const CommunityDeleteConfirmation: React.FC<CommunityDeleteProps> = ({
  isOpen,
  onClose,
  event,
}) => {
  const dispatch = useDispatch();
  const { masterCommunity: events, busy, message } = useCommunityMaster();
  const toast = useToast();
  useEffect(() => {
    const findEvent = events.find(
      (val: Record<string, any>) => val._id === event._id
    );
    if (!findEvent) {
      toast({
        title: "Success.",
        description: "selected data is deleted.",
        status: "success",
        isClosable: true,
        position: "top-right",
      });
      onClose();
    }
  }, [event, events, onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Data</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            {`Are you sure you want to delete this data?`}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose} disabled={busy}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={() => {
              dispatch({
                type: REQUEST_DELETE_MASTER_COMMUNITY,
                payload: { _id: event._id },
              });
              onClose();
            }}
          >
            Submit
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default CommunityDeleteConfirmation;
